import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Form, Input, Button, Spin, DatePicker } from "antd";
import {
  MISSATGE_CAMP_OBLIGATORI,
  MISSATGE_BAIXA_OBSERVADOR_ERROR,
  MISSATGE_BAIXA_OBSERVADOR_OK,
  MISSATGE_BAIXA_OBSERVADOR_TITOL,
  MISSATGE_SPIN_BAIXA_OBSERVADOR,
  MISSATGE_DATA_BAIXA_ANTERIOR_DATA_ALTA,
  TITOL_BAIXA_OBSERVADOR
} from "../../constantsFormularis";
import styles from "./ObservadorFormulariDonarBaixa.module.css";
import { NotificacioExit } from "../Notification";
import { fetchDonarBaixaObservador } from "../../actions/consultesServidor";
import { getDadesObservador } from "../../reducers";
import { setTitolApartat, errorConsultaServidor } from "../../actions";
import {
  MASCARA_DDMMYYYY,
  convertirTextAMomentLocal,
  esDiaAnterior
} from "../../utils/dates";
import { rutaDetallObservador } from "../../routes";

class ObservadorFormulariDonarBaixa extends Component {
  state = {
    canviEnCurs: false
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_BAIXA_OBSERVADOR);
  }

  setCanviEnCurs = value => {
    this.setState({ canviEnCurs: value });
  };

  getNomObservador = observador => {
    if (!observador) {
      return "";
    }

    const nomObservador = `${observador.nom
      ? observador.nom
      : ""} ${observador.cognom1 ? observador.cognom1 : ""} ${observador.cognom2
      ? observador.cognom2
      : ""}`;
    return nomObservador;
  };

  getDataAltaObservador = observador => {
    if (!observador) {
      return "";
    }

    const dataAlta =
      observador.historic[observador.historic.length - 1].dataAlta;
    if (!dataAlta) {
      return "";
    }
    return moment(dataAlta).format(MASCARA_DDMMYYYY);
  };

  getIdHistoricObservador = observador => {
    if (!observador) {
      return "";
    }

    const IdHistoric =
      observador.historic[observador.historic.length - 1].idHistoric;
    if (!IdHistoric) {
      return "";
    }
    return IdHistoric;
  };

  validatePosteriorDataAlta = (rule, value, callback) => {
    if (value) {
      const { dadesObservador } = this.props;
      const dataAlta = moment(
        dadesObservador.historic[dadesObservador.historic.length - 1].dataAlta
      );

      if (esDiaAnterior(value, dataAlta)) {
        callback(MISSATGE_DATA_BAIXA_ANTERIOR_DATA_ALTA);
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  handleCanvi = e => {
    this.setCanviEnCurs(true);
    e.preventDefault();
    const { form, dadesObservador, history } = this.props;
    const idObservador = dadesObservador.key;
    const idHistoric = this.getIdHistoricObservador(dadesObservador);
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const dataSeleccionada = convertirTextAMomentLocal(
          values.dataSeleccionada
        ).format(MASCARA_DDMMYYYY);

        fetchDonarBaixaObservador(
          idObservador,
          idHistoric,
          dataSeleccionada,
          values.motiubaixa
        ).then(
          dadesResultat => {
            form.resetFields();
            this.setCanviEnCurs(false);
            dadesResultat && dadesResultat.message
              ? this.props.errorConsultaServidor(
                  dadesResultat.titol,
                  dadesResultat.message
                )
              : dadesResultat
                ? NotificacioExit(
                    MISSATGE_BAIXA_OBSERVADOR_TITOL,
                    MISSATGE_BAIXA_OBSERVADOR_OK
                  )
                : this.props.errorConsultaServidor(
                    MISSATGE_BAIXA_OBSERVADOR_TITOL,
                    MISSATGE_BAIXA_OBSERVADOR_ERROR
                  );
            history.push({
              pathname: rutaDetallObservador
            });
          },
          error => {
            this.setCanviEnCurs(false);
            this.props.errorConsultaServidor(
              error,
              error.titol ? error.titol : MISSATGE_BAIXA_OBSERVADOR_ERROR
            );
          }
        );
      }

      this.setCanviEnCurs(false);
    });
  };

  render() {
    const { form, dadesObservador } = this.props;
    const { getFieldDecorator } = form;
    const nomObservador = this.getNomObservador(dadesObservador);
    const dataAlta = this.getDataAltaObservador(dadesObservador);
    const { TextArea } = Input;

    return (
      <Spin
        spinning={this.state.canviEnCurs}
        tip={MISSATGE_SPIN_BAIXA_OBSERVADOR}
        delay={0}
      >
        <div>
          <div className={styles.baixa_form}>
            <div>
              <span className={styles.campTitol}>{"Observador: "}</span>
              {nomObservador}
            </div>
            <div>
              <span className={styles.campDataBaixa}>{"Data alta: "}</span>
              {dataAlta}
            </div>
            <Form layout="vertical" onSubmit={this.handleCanvi}>
              <Form.Item
                label="Seleccionar la data de baixa"
                className={styles.label}
              >
                {getFieldDecorator("dataSeleccionada", {
                  rules: [
                    {
                      type: "object",
                      required: true,
                      message: "Aquest camp és obligatori"
                    },
                    { validator: this.validatePosteriorDataAlta }
                  ]
                })(
                  <DatePicker
                    placeholder="Seleccionar data"
                    format={MASCARA_DDMMYYYY}
                  />
                )}
              </Form.Item>
              <Form.Item label="Motiu baixa" className={styles.label}>
                {getFieldDecorator("motiubaixa", {
                  rules: [
                    {
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI
                    }
                  ]
                })(<TextArea rows={4} />)}
              </Form.Item>

              <Link
                className={styles.botoTornar}
                to={{
                  pathname: rutaDetallObservador,
                  query: { render: false }
                }}
              >
                <Button icon="left">Tornar</Button>
              </Link>

              <Button type="primary" htmlType="submit">
                Guardar
              </Button>

              <Form.Item />
            </Form>
          </div>
        </div>
      </Spin>
    );
  }
}

ObservadorFormulariDonarBaixa.propTypes = {
  dadesObservador: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    dadesObservador: getDadesObservador(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor
};

const WrappedNormalBaixaForm = Form.create({ name: "baixa_observador" })(
  ObservadorFormulariDonarBaixa
);

export default connect(mapStateToProps, mapDispatchToProps)(
  WrappedNormalBaixaForm
);
